const DATE_PREFIX = /^(\d{4})-(\d{2})-(\d{2})/;

export function indiaParts(date = new Date()) {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);
  const read = (type) => parts.find((part) => part.type === type)?.value || "00";
  return {
    year: read("year"),
    month: read("month"),
    day: read("day"),
    hour: read("hour"),
    minute: read("minute"),
    second: read("second"),
  };
}

export function indiaDate(value) {
  if (value == null || value === "") return "";
  const text = String(value).trim();
  const match = text.match(DATE_PREFIX);
  if (match && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(text)) return `${match[3]}/${match[2]}/${match[1]}`;
  const parsed = new Date(text);
  if (Number.isNaN(parsed.getTime())) return text;
  const parts = indiaParts(parsed);
  return `${parts.day}/${parts.month}/${parts.year}`;
}

export function indiaDateTime(value) {
  if (value == null || value === "") return "";
  const text = String(value).trim();
  const match = text.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/);
  if (match && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(text)) {
    if (!match[4]) return `${match[3]}/${match[2]}/${match[1]}`;
    return `${match[3]}/${match[2]}/${match[1]} ${match[4]}:${match[5]}`;
  }
  const parsed = new Date(text);
  if (Number.isNaN(parsed.getTime())) return text;
  const parts = indiaParts(parsed);
  return `${parts.day}/${parts.month}/${parts.year} ${parts.hour}:${parts.minute}`;
}

export function indiaDayKey(date = new Date()) {
  const parts = indiaParts(date);
  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function indiaMinute(date = new Date()) {
  const parts = indiaParts(date);
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`;
}

export function hasEnded(endAt) {
  const end = String(endAt || "").replace("T", " ").slice(0, 16);
  return Boolean(end && end < indiaMinute());
}
